import * as React from 'react';
import styled from 'styled-components';

export default class ActivationPopup extends React.PureComponent {

  render() {
    return (
      <PopUpContainer>
        <PopUpBody>
          {
            this.props.children
          }
        </PopUpBody>
      </PopUpContainer>
    );
  }

}
export const PopUpContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  background: rgba(0, 0, 0, .4);
  justify-content: center;
  align-items: center;
  z-index: 999999;
`;
export const PopUpBody = styled.div`
  padding: 1.5em;
  width:43%;
  max-height: 85%;
  overflow: auto;
  border-radius: 15px;
`;